import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowLeft01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';

function Pagination({ nPages, currentPage, setCurrentPage, length, handlePagination }) {

    const goToNextPage = () => {
        if (currentPage !== nPages) {
            setCurrentPage(currentPage + 1);
            handlePagination?.(currentPage + 1);
        }
    };

    const goToPrevPage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1);
            handlePagination?.(currentPage - 1);
        }
    };

    const goToPageClicked = (page) => {
        setCurrentPage(page);
        handlePagination?.(page);
    };

    const isFirst = currentPage === 1;
    const isLast  = currentPage === nPages;

    const pageBtn = (page) => {
        const active = currentPage === page;
        return (
            <button
                key={page}
                onClick={() => goToPageClicked(page)}
                className={`min-w-8 h-8 px-2 flex items-center justify-center rounded-lg text-sm font-medium tabular-nums transition-colors ${
                    active
                        ? 'text-white'
                        : 'text-gray-600 hover:bg-gray-100'
                }`}
                style={active ? { backgroundColor: '#1e3a6e' } : {}}
            >
                {page}
            </button>
        );
    };

    const visiblePages = () => {
        if (nPages <= 7) {
            return Array.from({ length: nPages }, (_, i) => i + 1).map(pageBtn);
        }
        return (
            <>
                {[1, 2, 3].map(pageBtn)}
                <span className="w-8 h-8 flex items-center justify-center text-gray-400 text-sm">…</span>
                {[nPages - 2, nPages - 1, nPages].map(pageBtn)}
            </>
        );
    };

    return (
        <div className="flex items-center justify-between px-5 py-3.5 border-t border-gray-100">
            <p className="text-xs text-gray-500 dark:text-gray-200">
                {nPages > 1 ? (
                    <>
                        Showing{' '}
                        <span className="font-semibold text-gray-700 dark:text-gray-200">
                            {currentPage > 1 ? currentPage * 10 - 9 : 1}
                        </span>
                        {' '}–{' '}
                        <span className="font-semibold text-gray-700 dark:text-gray-200">
                            {currentPage > 1 && currentPage * 10 > length ? length : currentPage * 10}
                        </span>
                        {' '}of{' '}
                        <span className="font-semibold text-gray-700 dark:text-gray-200">{length}</span>
                    </>
                ) : (
                    <>
                        <span className="font-semibold text-gray-700 dark:text-gray-200">{length}</span> result{length !== 1 ? 's' : ''}
                    </>
                )}
            </p>

            <div className="flex items-center gap-1">
                <button
                    onClick={goToPrevPage}
                    disabled={isFirst}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                        isFirst ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-100'
                    }`}
                >
                    <HugeiconsIcon icon={ArrowLeft01Icon} size={14} />
                    Previous
                </button>

                <div className="flex items-center gap-0.5 mx-1">
                    {visiblePages()}
                </div>

                <button
                    onClick={goToNextPage}
                    disabled={isLast}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                        isLast ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-100'
                    }`}
                >
                    Next
                    <HugeiconsIcon icon={ArrowRight01Icon} size={14} />
                </button>
            </div>
        </div>
    );
}

export default Pagination;
